import { browserHistory } from 'react-router';
import { syncHistoryWithStore } from 'react-router-redux';

let history: ReturnType<typeof syncHistoryWithStore>;

export const supportsHistory = (): boolean => {
  const ua = window.navigator.userAgent;

  if (
    (ua.indexOf('Android 2.') !== -1 || ua.indexOf('Android 4.0') !== -1) &&
    ua.indexOf('Mobile Safari') !== -1 &&
    ua.indexOf('Chrome') === -1 &&
    ua.indexOf('Windows Phone') === -1
  ) {
    return false;
  }

  return window.history && 'pushState' in window.history;
};

export const getHistory = (store: $TSFixMe): typeof history => {
  if (!history) {
    history = syncHistoryWithStore(browserHistory, store, {
      adjustUrlOnReplay: supportsHistory(),
    });
  }
  return history;
};
